import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

// Actions
import { getPriceList, updatePriceList, getShopCustomerAgreement } from '../../../../actions/priceModel'
import { getShopCustomers } from '../../../../actions/customerGroup'

// import styles
// import './discounts.scss'

// Utils
import { translation } from '../../../../utils/helpers'

// import { formatCurrency, reverseFormatCurrency } from '../../../utils/currency'
import { hasAccess } from '../../../../utils/auth'
import Insurance from '../Insurance'
import Delivery from '../../../Settings/Delivery'
import AgreementDetails from '../Details'
import QualityCheckSettingsChild from '../../../QualityCheckSettings/QualityCheckSettingsChild'

// Elements
import Row from '../../../../shared/elements/row'
import Col from '../../../../shared/elements/col'
import Panel from '../../../../shared/elements/panel'
import DropDown from '../../../../shared/elements/dropDown'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import TabBar from '../../../../shared/elements/tabBar'
import TabItem from '../../../../shared/elements/tabItem'

class SelectCustomer extends Component {

  constructor (props) {
    super(props)
    this.state = {
      customersList: [],
      selectedCustomerId: props.selectedCustomerId,
      selectedShopId: props.selectedShopId,
      selectedCustomerTab: -1,
      activeItem: {},
      priceModelId: props.agreementId,
      agreementPrice: {}
    }
    this.onInputChange = this.onInputChange.bind(this)
  }

  componentDidMount () {
    this.getCustomersList(this.props)
    this.setState({
      activeItem: this.props.item
    })
    this.state.isCustomer = hasAccess([4], this.props.auth.user.UserType)
    this.state.isShop = hasAccess([3, 5, 7], this.props.auth.user.UserType)
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(nextProps.selectedCustomerId, this.props.selectedCustomerId) || !isEqual(nextProps.selectedShopId, this.props.selectedShopId)) {
      console.log(this.props)
      this.setState({
        selectedCustomerId: nextProps.selectedCustomerId,
        selectedShopId: nextProps.selectedShopId,
        priceModelId: nextProps.agreementId
      }, () => {
        if (nextProps.item !== null && nextProps.item !== undefined) {
          // this.props.getPriceList(nextProps)
        }
      })
    }
    if (!isEqual(nextProps.item, this.props.item)) {
      this.setState({
        activeItem: nextProps.item,
        priceModelId: nextProps.item !== null ? nextProps.item.PriceModelId : -1
      })
    }
    // Get agreement again when clicking away from shops tab
    if (!isEqual(nextProps.selectedTabIndex, this.props.selectedTabIndex) && nextProps.selectedTabIndex !== 1) {
      this.props.getPriceModel(nextProps, this.props.agreementId)
    }
  }

  getCustomerAgreement (agreementId, customerId, companyId) {
    this.props.getShopCustomerAgreement(agreementId, customerId, companyId).then((res) => {
      this.setState({
        agreementPrice: res.data
      }, () => {
      })
    }, () => {
      // Toastr
      window.toastr.error(translation('13445'), translation('216'))
      this.props.onShouldUpdate()
    })
  }

  getCustomersList (props) {
    return props.getShopCustomers(props.item.CustomerGroupId).then((res) => {
      this.setState({
        customersList: res.data
      })
      return res
    }, () => {
      console.log('Err fetching price lists data')
      return null
    })
  }

  onInputChange (e) {
    e.persist()
    let value = e.target.value
    // if (typeof value === 'string') {
    //   value = parseInt(value.split('_')[0])
    // }
    let name = e.target.name
    if (name === 'selectedCustomerId') {
      // let el = document.querySelector('select[name="selectedCustomerId"] option:checked')
      // let shopId = parseInt(el.getAttribute('data-shopId'))

      // value = <customerId>_<shopId>
      const values = value.split('_')
      this.props.selectCustomer(values[0], values[1])

      this.setState({
        selectedCustomerTab: -1
      }, () => {
        this.getCustomerAgreement(this.state.priceModelId, this.props.selectedCustomerId, this.props.selectedShopId)
      })
    }
    // if (name === 'btnMenuTab') {
    //   this.setState({
    //     selectedCustomerTab: Number(value)
    //   }, () => {
    //     if (this.state.selectedCustomerTab === 0) {
    //       this.getCustomerAgreement(this.state.priceModelId, this.props.selectedCustomerId, this.props.selectedShopId)
    //     }
    //   })
    // }
  }
  renderCustomerSelect () {
    // if (this.state.price.Name === null) return null
    // let { price } = this.state
    // let isCustomer = (hasAccess([4], this.props.auth.user.UserType))
    let customersList = this.state.customersList
    let grouping = []
    for (let i = 0; i < customersList.length; i++) {
      let group = grouping.find((val, idx) => { return val.shopName === customersList[i].ShopName })
      if (group === undefined) {
        group = {
          shopName: customersList[i].ShopName,
          shopId: customersList[i].ShopId,
          customersList: []
        }
        grouping.push(group)
      }
      group.customersList.push(customersList[i])
      group.customersList.sort((a, b) => a.Name.localeCompare(b.Name)) // a.Name > b.Name)
    }
    grouping.sort((a, b) => a.shopName.localeCompare(b.shopName)) // a.shopName > b.shopName)
    // let selectedCustomerId = parseInt(this.props.selectedCustomerId)
    // let selectedShopId = parseInt(this.props.selectedShopId)

    const renderGroup = (group, key) => {
      const renderItem = (shopId, val, key) => {
        // console.log('shopId', shopId, 'customerId', val.CustomerId, 'props', this.props.selectedShopId, this.props.selectedCustomerId)
        // let selected = parseInt(val.CustomerId) === selectedCustomerId && parseInt(shopId) === selectedShopId
        // if (selected) {
        //   console.log('SELECTED ', selectedShopId, selectedCustomerId)
        // }
        const value = val.CustomerId + '_' + shopId
        return (<option value={value} key={val.CustomerId}>{val.Name}</option>)
      }
      let shopName = group.shopName
      let shopId = group.shopId
      // console.log('shopId ', shopId, 'group', group)
      return (
        <optgroup label={shopName} key={shopName}>
          {group.customersList.map((val, key) => renderItem(shopId, val, key))}
        </optgroup>
      )
    }
    // let isCustomer = this.props.customer
    const renderCustomersList = () => {
      // console.log('select value = ', this.state.selectedCustomerId + '_' + this.state.selectedShopId)
      const value = this.state.selectedCustomerId + '_' + this.state.selectedShopId
      return (
        <LabelWrapper labelText={this.props.item.Name}>
          <DropDown name='selectedCustomerId' value={value} onChange={this.onInputChange} isGrouping>
            <option value='-1' key='-1'>{translation('890')}</option>
            {grouping.map(renderGroup)}
          </DropDown>
        </LabelWrapper>
      )
    }
    return (
      <Panel title={translation('12281')}>
        {renderCustomersList()}
        {this.renderCustomerMenuButtons()}
      </Panel>
    )
  }
  renderCustomerMenuButtons () {
    // if (this.props.route.customer) return null
    if (!hasAccess([6], this.props.auth.user.UserType) || this.state.selectedCustomerId < 0) return null
    let isAddon = this.state.activeItem.PriceType === 8
    // const buttonClass = (val) => {
    //   let btn = 'button'
    //   if (val === this.state.selectedCustomerTab) return 'button active'
    //   return btn
    // }
    // Aftale 13472
    // Kvalitetstjek 13421
    // Leveringstider 196
    const onTabClick = (value) => {
      this.setState({
        selectedCustomerTab: Number(value)
      }, () => {
        if (this.state.selectedCustomerTab === 0) {
          this.getCustomerAgreement(this.state.priceModelId, this.props.selectedCustomerId, this.state.selectedShopId)
        }
      })
    }

    const priceModelButtons = () => {
      return (
        <TabBar>
          <TabItem name='btnMenuTab' onClick={() => onTabClick(0)} value='0' active={this.state.selectedCustomerTab === 0} labelText={translation('13472')} />
          {!isAddon && <TabItem name='btnMenuTab' onClick={() => onTabClick(1)} value='1' active={this.state.selectedCustomerTab === 1} labelText={translation('13421')} />}
          {!isAddon && <TabItem name='btnMenuTab' onClick={() => onTabClick(2)} value='2' active={this.state.selectedCustomerTab === 2} labelText={translation('196')} />}
        </TabBar>)
    }
    return (
      priceModelButtons()
    )
  }
  render () {
    let view = null
    // let classname = ''
    if (this.state.activeItem === null || this.props.item === null || this.state.PriceModelId <= 0) return null
    // let isAgeement = this.props.item.PriceModelId > 0 && this.state.selectedCustomerTab === 0
    // let isQuality = this.state.selectedCustomerTab === 1
    // let isDelivery = this.state.selectedCustomerTab === 2
    let hasSelectedCustomer = this.state.selectedCustomerId > 0
    let pricetype = Number(this.props.item.PriceType)
    switch (this.state.selectedCustomerTab) {
      case 0:
        if (pricetype !== 5 && pricetype !== 6 && pricetype !== 0 && !this.state.activeItem.UseEstimationList) {
          view = <AgreementDetails
            onShouldUpdate={this.props.onShouldUpdate}
            selectedTabIndex={this.state.selectedCustomerTab}
            item={this.state.activeItem}
            selectedCustomerId={this.state.selectedCustomerId}
            selectedShopId={this.state.selectedShopId}
            customer={this.props.customer}
            partners={this.props.partners}
            agreementId={this.props.item.PriceModelId}
            agreementPrice={this.state.agreementPrice}
            getPriceLists={this.props.getPriceLists.bind(this)} />
        } else {
          view = <Insurance ref='view'
            selectedTabIndex={this.state.selectedCustomerTab}
            onShouldUpdate={this.props.onShouldUpdate}
            isMain={false}
            item={this.state.activeItem}
            selectedCustomerId={this.state.selectedCustomerId}
            selectedShopId={this.state.selectedShopId}
            pricemodels={this.props.pricemodels}
            agreementId={this.props.item.PriceModelId}
            agreementPrice={this.state.agreementPrice}
            getPriceLists={this.props.getPriceLists.bind(this)} />
        }
        break
      case 1:
        view = <QualityCheckSettingsChild ref='view'
          selectedTabIndex={this.state.selectedCustomerTab}
          onShouldUpdate={this.props.onShouldUpdate}
          isAgreement
          item={this.state.activeItem}
          selectedCustomerId={this.state.selectedCustomerId}
          selectedShopId={this.state.selectedShopId}
          pricemodels={this.props.pricemodels}
          agreementId={this.props.item.PriceModelId}
          agreementPrice={this.state.agreementPrice}
          getPriceLists={this.props.getPriceLists.bind(this)} />
        break
      case 2:
        view = <Delivery ref='view'
          selectedTabIndex={this.state.selectedCustomerTab}
          onShouldUpdate={this.props.onShouldUpdate}
          isAgreement
          isShop={false}
          selectedCustomerId={this.state.selectedCustomerId}
          selectedShopId={this.state.selectedShopId}
          pricemodels={this.props.pricemodels}
          agreementId={this.state.activeItem.PriceModelId}
          agreementPrice={this.state.agreementPrice}
          getPriceLists={this.props.getPriceLists.bind(this)} />
        break
      default: break
    }
    if (!hasSelectedCustomer) view = null
    // let customerSelectClass = 'customer__select '
    // if (!hasSelectedCustomer) customerSelectClass += 'none_selected'
    return (
      <div>
        <div className={hasSelectedCustomer ? 'select-customer' : ''}>
          <Row>
            <Col span={2}>
              {this.renderCustomerSelect()}
            </Col>
          </Row>
        </div>
        {view}
      </div>
    )
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    agreementPrice: state.agreementPrice,
    selectedCustomerTab: state.selectedCustomerTab
  }
}

export default connect(mapStateToProps, {
  getPriceList,
  updatePriceList,
  getShopCustomers,
  getShopCustomerAgreement
})(SelectCustomer)



// WEBPACK FOOTER //
// ./src/app/pages/PriceAgreements/Agreements/SelectCustomer/index.js